import {
  $addClass,
  $append,
  $findAll,
  $qs,
  $qsa,
  $removeClass,
  $setHTML,
  $setScrollTop,
  $setText,
} from 'fxdom/es';
import { each, go, find, groupBy, sel, map, noop, omit, pluck, sortBy } from 'fxjs/es';
import querystring from 'querystring';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { OMPCoreUtilF } from '../../../Core/Util/F/Function/module/OMPCoreUtilF.js';
import { OMPProductListTmplS } from '../../S/Tmpl/module/OMPProductListTmplS.js';
import { axiosGetBps, axiosGetFilters } from './fn.js';
import { Switch } from '../../../../../services/Marpple/client/shared/ui/atoms/Switch/Switch.ts';
import { campaignLikeCateItem } from '../../S/Function/campaign-like-cate-item.ts';
import { SubInteractiveMenu } from '../../../../../services/Marpple/client/widgets/sub-menu/sub-interactive-menu/sub-interactive-menu.ts';
import { SubInteractiveMenuMo } from '../../../../../services/Marpple/client/widgets/sub-menu/sub-interactive-menu/sub-interactive-menu-mo.ts';
import { BodyNavigation } from '../../../../../services/Marpple/client/widgets/body-navigation/body-navigation.ts';

const queue = [];

export const finishActionBpList = async (query) => {
  const cate_list_id = query.cate_list_id;
  const cate_item_id = query.cate_item_id;

  const { cate_list_name, cate_item_name, description, og_img, og_title } = go(void 0, () => {
    const cate_list = find((_cate_list) => {
      return _cate_list.id == cate_list_id;
    }, box.sel('cate_lists'));
    const cate_item = find(
      (ci) => {
        return ci.id == cate_item_id;
      },
      sel('_.cate_list_sub_menus', cate_list),
    );
    return {
      cate_list_name: cate_list.name,
      cate_item_name: cate_item?.name,
    };
  });

  $setText(`${TT('omp_layout::title')} ${cate_item_name || cate_list_name}`, $qs('title'));
  if (query.sort === 'pick') {
    delete query.sort;
  }
  if (!query.campaign_id) {
    delete query.campaign_id;
  }
  if (!query.cate_item_id) {
    delete query.cate_item_id;
  }

  const query_string = querystring.stringify(omit('cate_list_id', query));

  MuiF.extendHistoryState(
    null,
    null,
    `/${TT.lang}/product/list/${cate_list_id}${query_string ? `?${query_string}` : ``}`,
    true,
  );
  $setScrollTop(0, window);
  OMPCoreUtilF.imageLazyLoad();

  OMPCoreUtilF.hydrationRune(Switch);

  if (OMPCoreUtilF.isMobile()) {
    $qs('.mp-header-ham__item[data-active="true"]').dataset.active = 'false';
    $qs(`.mp-header-ham__item[data-id="${query.cate_list_id}"]`).dataset.active = 'true';
  }
};
const makeQuery = (cate) => {
  const { cate_list_id, cate_item_id, campaign_id } = $qs('.omp-product-list__checked-cate-list').dataset;
  const is_biz = $qs('#omp-product-list__is-biz-switch')?.getAttribute('data-checked') === 'true';
  const checked_cate_list_id = cate ? cate.cate_list_id : cate_list_id;
  const checked_cate_item_id = cate ? cate.cate_item_id : cate_item_id;
  const checked_campaign_id = cate ? cate.campaign_id : campaign_id;
  const sort = $qs('.omp-product-list__checked-sort-name').dataset.id;
  return go(
    $qsa('.omp-product-filter-item__input-checkbox:checked'),
    map((input) => {
      return {
        name: input.name,
        id: input.value,
      };
    }),
    groupBy(({ name }) => {
      return name;
    }),
    Object.entries,
    map(([name, filters]) => {
      return [name, pluck('id', filters)];
    }),
    Object.fromEntries,
    (filters) => {
      return {
        cate_list_id: checked_cate_list_id,
        ...(checked_campaign_id
          ? { campaign_id: checked_campaign_id }
          : checked_cate_item_id
            ? { cate_item_id: checked_cate_item_id }
            : {}),
        sort,
        ...(is_biz ? { is_biz } : {}),
        ...filters,
      };
    },
  );
};

export const reloadByFilter = async () => {
  const list_body$ = $qs('.opm-product-list-bps');
  const check_filter_items$ = $qs('.opm-product-list-checked-filter-items');
  const check_filter_length = $findAll('button', check_filter_items$).length;
  if ((check_filter_items$.dataset.list_show == 'true') != check_filter_length > 0) {
    $setHTML('', list_body$);
    check_filter_items$.dataset.list_show = check_filter_length > 0;
    list_body$.dataset.filter_show = check_filter_length > 0;
  }
  const query = makeQuery();
  const promise = axiosGetBps(query);
  queue.push(promise);
  const bps = await promise;
  if (queue[queue.length - 1] == promise) {
    queue.splice(0);
    $setHTML(OMPProductListTmplS.pcListBody(bps, query), list_body$);
    finishActionBpList(query);
    const countEl = $qs('.omp-product-list__cate-item-counts', document.body);
    if (countEl) {
      $setText(TT('product::list::list_25_1', { count: bps.length }), countEl);
    }
  }
};

export const changeSort = (currentTarget, func) => {
  const checked_name$ = $qs('.omp-product-list__checked-sort-name');
  const sort = currentTarget.dataset.id;
  if (checked_name$.dataset.id != sort) {
    checked_name$.dataset.id = sort;
    $setText(currentTarget.dataset.name, checked_name$);
    const list$ = $qs('.omp-product-list__list');
    go(
      $qsa('.omp-cell__product[data-id], .omp-cell__product-mo[data-id]'),
      sortBy(({ dataset }) => {
        if (sort == 'pick') {
          return parseInt(dataset.no);
        } else if (sort == 'low_price') {
          return parseFloat(dataset.price);
        } else if (sort == 'high_price') {
          return -parseFloat(dataset.price);
        }
      }),
      each((bp$) => {
        $append(bp$, list$);
      }),
      noop,
      func,
    );
  }
};

export const reloadBySort = (currentTarget) => {
  return changeSort(currentTarget, () => {
    finishActionBpList(makeQuery());
  });
};

function dealWithCampaignClassByQuery(query) {
  if (campaignLikeCateItem.isCampaign(query)) {
    go(
      [$qs('html'), $qs('body')],
      each((el) => $addClass('is_campaign', el)),
    );
  } else {
    go(
      [$qs('html'), $qs('body')],
      each((el) => $removeClass('is_campaign', el)),
    );
  }
}

export const reloadByCate = async ({ cate_list_id, cate_item_id, campaign_id }) => {
  /* .omp-product-list__checked-cate-list 를 바꾸지 않고 pcList 를 새로 그리기 때문에 일반적으로 다르다. */
  const query = makeQuery({ cate_list_id, cate_item_id, campaign_id });
  const promise = Promise.all([axiosGetBps(query), axiosGetFilters(query)]);
  queue.push(promise);
  const [bps, bp_filters] = await promise;
  if (queue[queue.length - 1] == promise) {
    queue.splice(0);
    const checked_cate_list = box.sel('cate_lists').find(({ id }) => {
      return id == query.cate_list_id;
    });
    checked_cate_list._.cate_list_sub_menus.forEach((item) => {
      item.active = false;
    });
    const query_campaign_id = campaignLikeCateItem.getCampaignId(query);
    const checked_cate_item = checked_cate_list._.cate_list_sub_menus.find(({ id, campaign_id }) => {
      if (query_campaign_id) {
        return query_campaign_id == campaign_id;
      }

      if (query.cate_item_id) {
        return id == query.cate_item_id;
      }
      return false;
    });
    if (checked_cate_item) {
      checked_cate_item.active = true;
    }
    dealWithCampaignClassByQuery(query);
    $setHTML(
      OMPProductListTmplS.pcList({
        checked_cate_list,
        checked_cate_item,
        bps,
        query,
        checked_filter_items: [],
      }),
      $qs('.omp-layout-body__cont'),
    );
    $setHTML(OMPProductListTmplS.leftFilter(bp_filters), $qs('.omp-left__filter-list'));
    finishActionBpList(query);
    const activeId = checked_cate_item?.campaign_id || checked_cate_item?.id;
    SubInteractiveMenu.interactAfterReload(activeId);
  }
};

export const reloadByCateMobile = async ({ cate_list_id, cate_item_id, campaign_id }) => {
  /* .omp-product-list__checked-cate-list 를 바꾸지 않고 pcList 를 새로 그리기 때문에 일반적으로 다르다. */
  const query = makeQuery({ cate_list_id, cate_item_id, campaign_id });
  const promise = Promise.all([axiosGetBps(query)]);
  queue.push(promise);
  const [bps] = await promise;
  if (queue[queue.length - 1] == promise) {
    queue.splice(0);
    const checked_cate_list = box.sel('cate_lists').find(({ id }) => {
      return id == query.cate_list_id;
    });
    checked_cate_list._.cate_list_sub_menus.forEach((item) => {
      item.active = false;
    });
    const query_campaign_id = campaignLikeCateItem.getCampaignId(query);
    const checked_cate_item = checked_cate_list._.cate_list_sub_menus.find(({ id, campaign_id }) => {
      if (query_campaign_id) {
        return query_campaign_id === campaign_id;
      }
      if (query.cate_item_id) {
        return id == query.cate_item_id;
      }
      return false;
    });
    if (checked_cate_item) {
      checked_cate_item.active = true;
    }
    dealWithCampaignClassByQuery(query);
    const productListBody = $qs('.omp-product-list__mo_body');
    $setHTML(
      OMPProductListTmplS.moListNotFirstRender({
        checked_cate_list,
        checked_cate_item,
        bps,
        query,
        checked_filter_items: [],
      }),
      productListBody,
    );
    finishActionBpList(query);
    const activeId = checked_cate_item?.campaign_id || checked_cate_item?.id;
    SubInteractiveMenuMo.interactAfterReload(activeId);
    BodyNavigation.interactAfterReload(activeId);
  }
};
